import BaseFormComponent from '../BaseFormComponent';
export class TextareaComponent extends BaseFormComponent {
    constructor() {
        super(...arguments);
        this.placeholder = null;
        this.textAlign = 'left';
        this.size = 'normal';
        this.previewMode = 'no';
        this.disabled = false;
        this.monospace = false;
        this.rows = 4;
    }
}
